import React from 'react';

export default class areaTexto extends React.Component {

    componentDidUpdate = () => {
        this.validarAcciones();
    }

    validarAcciones = () => {
        const { id, attributes } = this.props;
        const component = this.refs[id];
        if (attributes.focus) component.focus();
    }

    handleFocus = (event) => event.target.select();

    render() {
        const { id, label, value, attributes, onChangeInput, onKeyPress } = this.props;
        const readOnlyAttr = attributes.readOnly ? { readOnly: 'readOnly' } : {};
        const keyPressAttr = onKeyPress ? { onKeyPress: onKeyPress } : {};
        const maxLength = attributes.maxLength ? attributes.maxLength : '';
        const minLength = attributes.minLength ? attributes.minLength : '';

        return (

            <div className="form-group">
                <label htmlFor={id}>{label}</label>
                <textarea className="form-control" onChange={onChangeInput} name={id} id={id} ref={id} maxLength={maxLength} minLength={minLength} {...readOnlyAttr} {...keyPressAttr} value={value} />
            </div>

        )
    }
}
